// global.gsap = require("gsap");
import gsap from "gsap";
import testWebp from "./modules/sub/testwebp";
import CssFilterConverter from 'css-filter-converter';

global.gsap = gsap;

"use scrict";

global.$ = require("jquery");
var MobileDetect = require('mobile-detect');
global.md = new MobileDetect(window.navigator.userAgent);
global.MOBILE = md.mobile();
global.CssFilterConverter = CssFilterConverter;

var mainWidth;

global.remToPx = function(x){
  return (parseInt($('html').css('font-size')) * x);
}

global.TOUCH = (('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0));

global.TABLET = navigator.maxTouchPoints &&
    navigator.maxTouchPoints > 2 &&
    /MacIntel/.test(navigator.platform);

// const webpTest = new testWebp();
// global.WEBP = webpTest.result;

// const imagesLoaded = require("imagesLoaded");

import home from './modules/home';
import home_3d from './modules/home3d';
import index from './modules/index';
import project from './modules/project';
import studio from './modules/studio';
// import main from './modules/main';

global.isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));


// var filter = new CssFilterConverter;
var dofilter = CssFilterConverter.hexToFilter($('html').css('--color'));
if(!isSafari) {
  if(dofilter.loss < 2) {
    document.documentElement.style.setProperty('--colorFilter', dofilter.color);
  } else {
    dofilter = CssFilterConverter.hexToFilter($('html').css('--color'));
    if(dofilter.loss < 2) {
      document.documentElement.style.setProperty('--colorFilter', dofilter.color);
    } else {
      dofilter = CssFilterConverter.hexToFilter($('html').css('--color'));
      document.documentElement.style.setProperty('--colorFilter', dofilter.color);
    }
  }
}

$(function(){

  // WEBP = webpTest.result;
  // console.log('webp support', WEBP);

  window.maxvh = 0;
  window.projectHidden = true;

  vh();

  initOnce();

  initPage();


  $(window).on('popstate', function(e){
    var loc = window.location.href;
    if(loc.substr(loc.length-1,1) != '#') {
      window.location.href = loc;
    }
    // console.log('pop', e);
    // ajaxload(window.location.href, null, false);
  });

});

window.runKeksi = function(){
  var doCookie = true;
  // $('.notis').slideDown(300);

  if(window.localStorage.getItem('note-notis-cookie')){
    var diff = (Date.now() - parseInt(window.localStorage.getItem('note-notis-cookie'))) / 1000;
    let day = 86400;
    let week = 604800;
    if(diff < week) {
      doCookie = false;
    }
    if(doCookie) {
      $('.keksi').addClass('in');
    }
  } else {
    setTimeout(function(){
      $('.keksi').addClass('in');
    }, 2000);
  }

  $('.noti--close').click(function(e){
    e.preventDefault();
    $(this).parents('.noti').removeClass('in');
    window.localStorage.setItem('note-notis-cookie',Date.now());
  });
}


function initPage() {
  console.log('initpage');

  if(isSafari) {
    $('html').addClass('safari');
  }

  if(TABLET) {
    $('html').addClass('tablet');
  }

  binds();

  $('.video--sound').parent().addClass('ptr');

  var indexTitleDone = false;

  // $(window).unbind('scroll');

  if($('.home--cols').length>0) {
    if(TOUCH && $('.mobhome').length==0) {
      if(md.tablet()||TABLET){
        window.location.href = siteurl+'?tab=1';
      } else {
        window.location.href = siteurl+'?mob=1';
      }
      return false;
    } else {
      if(window.location.href.indexOf('?tab')>=0){
        window.history.replaceState('','',siteurl);
      }
      if(window.location.href.indexOf('?mob')>=0){
        window.history.replaceState('','',siteurl);
      }
      if(!window.home) {
        window.home = new home();
      } else {
        console.log('already had home');
        window.home.binds();
        if(TOUCH){
          $('.home--cols--col--text').css('opacity',1);
        } else {
          setTimeout(function(){
            $('.home--cols--col--text').css('opacity',1);
          }, 500);
        }
      }
      window.isHome = true;
    }
  }

  if($('.home3d').length>0) {
    if(!window.home) {
      window.home = new home_3d();
    } else {
      console.log('already had home');
    }
    window.isHome = true;
  }

  if($('.index--wrap').length>0) {
    if(localStorage.getItem('note-indextitledone')=='yes') {
      indexTitleDone = true;
    }
    setTimeout(function(){
      localStorage.setItem('note-indextitledone','yes');
      window.noScrollDetect = false;
      // $(window).trigger('scroll');
    }, 1500);
    if(!window.index){
      window.index = new index();
    }
  }

  if($('html').hasClass('studio')) {
    window.studio = new studio();
  } else {
    clearInterval(window.studiotime);
    window.studiotime = null;
  }

  if($('html').hasClass('project')) {
    $('.content-block img:not(.ok), .content-block video:not(.ok)').each(function(){
      let tarpar = $(this).parents('ul[style]').first();
      if(tarpar){
        $(tarpar).css('opacity',0);
        setTimeout(function(){ $(tarpar).addClass('trans'); },1);
      }
    });

    window.project = new project();
    indexTitleDone = false;
  }

  if($('html').hasClass('studio') || $('html').hasClass('default')) {
    $('.header').addClass('huge').css('opacity',1);
  }

  setTimeout(function(){
    $('.noti').addClass('do');
  }, 100);

  if(!window.isHome||window.homeconstructed){
    window.runKeksi();
  }

  $('body').addClass('in');
  $('.wrap:not(.end-sticky)').animate({'opacity':1}, 200, function(){
    $('.colophon').fadeIn(200);
    if(!window.linkClone&&!indexTitleDone&&!window.doflashtitle){
      $('.page--title').css({'opacity' : 1});
      var len = $('.page--title').children().length;
      if(len>0) {
        setTimeout(function(){
          $('.page--title').children().each(function(idx){
            var t = $(this);
            setTimeout(function(){
              $(t).css('opacity', 0);
            }, 150 * (len-idx));
          });
        }, 2000);
      } else {
        setTimeout(function(){
          $('.page--title').animate({'opacity' : 0}, 300);
        }, 1500);
      }
    }
  });

  if($('.default--wrap').length>0) {
    setTimeout(function(){
      $('.default--wrap').animate({'opacity':1}, 300);
    }, 1000);
  }


  $('.duo--parent > ul, .single').each(function(idx){
    $(this).find('[data-src]').attr('data-idx', idx);
  });

  setTimeout(function(){
    checkFirstView();
    window.localStorage.setItem('note-home-biglogo', Date.now());
    $('.scroller').addClass('anim');
  }, 500);

  if(window.innerWidth < 787) {
    $('.colophon:not(.mobonly').unbind('touchstart').on('touchstart', function(){
      clearInterval(window.scrollColophon);
    });
  }

  initSlides();
}

function initSlides(){
  if(window['projectanims']){
    for(var i=0; i<window['projectanims'].length; i++){
      window.clearInterval(window.projectanims[i]);
    }
  }
  window.projectanims = [];
  $('[data-duration]').each(function(idx){
    var id = $(this).attr('id');
    if(id==undefined) {
      id = $(this).parents('.imageset').attr('id');
    }
    var duration = $(this).attr('data-duration')*1000;

    var container = this;
    var interval_id = `intervals_${id}`;
    // window.clearInterval(window.projectanims[interval_id]);
    window.projectanims[idx] = setInterval(function(){
      var curAct = container.querySelector('.act');
      if(curAct){
        var next = curAct.nextElementSibling;
        if(!next) { next = container.querySelector('li'); }
        curAct.classList.remove('act');
        next.classList.add('act');
      }
    }, duration);
  });
}

function checkFirstView(){
  $('[data-src]:not(.ok):not(.loading), .image--project img:not(.ok):not(.loading)').each(function(idx){
    if(this.getBoundingClientRect().top < window.innerHeight*1.5){
      let src = $(this).attr('data-src');
      var srcset = $(this).attr('data-srcset');
      // if(!WEBP) {
      //   srcset = $(this).attr('data-srcset-jpeg');
      // }
      $(this).addClass('loading');
      let t = $(this).get(0);
      var delay = $(this).attr('data-idx');
      if($(t).is('video')){
        t.onload = function(){
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }, delay * 100 + 50);
        }
        t.onloadeddata = function(){
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }, delay * 100 + 50);
        }
        t.src = src;
      } else {
        /*
        if(t.complete) {
          // console.log('img was complete');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading'); //.attr('src',src);
          }, delay * 100 + 50);
        }
        t.onload = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading'); //.attr('src',src);
          }, delay * 100 + 50);
        }
        t.onloadeddata = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading'); //.attr('src',src);
          }, delay * 100 + 50);
        }
        */

        // $(t).attr({
        //   'src' : src,
        // });
        // if(srcset) {
        //   $(t).attr({
        //     'srcset' : srcset
        //   });
        // }

        let img = new Image();
        if(img.complete) {
          // console.log('img was complete');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }, delay * 100 + 50);
        }
        img.onload = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }, delay * 100 + 50);
        }
        img.onloadeddata = function(){
          // console.log('img load');
          setTimeout(function(){
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }, delay * 100 + 50);
        }
        img.src = src;
        t.src = src;
        if(srcset) img.srcset = srcset;
        if(srcset) t.srcset = srcset;
      }
    }
  });
}

window.ajaxload = function(url, clickedlink, pushstate=true, dolarge = false) {
  // console.log(url, clickedlink, pushstate);
  window.preventTitleHovers = true;
  window.navigating = true;

  $('body').removeClass('in');

  $('.header').addClass('nomixblendmode');
  setTimeout(function(){ $('.header').removeClass('nomixblendmode'); }, 1);

  $('html').attr('class','project');

  $('.menu-button, .index-views').addClass('out');

  $('.clonetitle').remove();

  $('.home--cols').addClass('force-hide-titles');

  if(clickedlink){
    var linkRect = clickedlink.getBoundingClientRect();
    $(clickedlink).removeClass('in').addClass('force-out');
    // do fancy project thing
    console.log(clickedlink);
    window.linkClone = $(clickedlink).first().clone();
    $(window.linkClone).addClass('clonetitle').removeClass('in');
    $(window.linkClone).find('.index-project--text').remove();
    $(window.linkClone).find('img').remove();

    var insert = $('.wrap').first();

    $(window.linkClone).css({
      'left' : linkRect.left,
      'width' : linkRect.width,
      'top' : linkRect.top,
      'pointer-events' : 'none',
      'position' : 'fixed',
      'z-index' : 10,
    }).insertBefore(insert);
  }

  // var curWrap = $('.wrap:not(.end-sticky)');
  // var currentlyProject = $('html').hasClass('project');

  // $('.wrap').animate({'opacity':0}, 300);

  var mainWrap = $('.wrap:not(.wrap-project');

  if(clickedlink || $(mainWrap).attr('data-htmlclass')=='studio') {
    window.prevScroll = $(window).scrollTop();
  }

  // if(!MOBILE) window.prevScroll -= 40;

  $.get(url, function(data){

    if(clickedlink) {
      $(clickedlink).removeClass('force-out');
    }

    $(window).scrollTop(0);

    window.preventTitleHovers = false;

    var projectWrap = $(data).filter('.wrap:not(.end-sticky)');
    var cls = $(data).filter('.wrap').attr('data-htmlclass');

    // console.log(projectWrap);
    if($('.wrap-project').length==0){
      $(projectWrap).hide();
      $(projectWrap).insertBefore('.wrap');
      $(projectWrap).addClass('wrap-project');
      // $('<div class="wrap wrap-project">').insertBefore('.wrap');
    } else {
      $('.wrap-project').replaceWith(projectWrap);
    }

    $('html').attr('class',cls);

    // to accommodate for flickering
    $(mainWrap).css('opacity', 0);

    if(isSafari){
      $('.wrap').off('mousewheel').on('mousewheel', function(e){
        if($(this).hasClass('end-sticky')){
          e.preventDefault();
          $('html').scrollTop($('html').scrollTop() + e.originalEvent.deltaY);
        }
      });
    }

    $('.content-block img:not(.ok), .content-block video:not(.ok)').each(function(){
      $(this).parents('ul[style]').first().css('opacity',0);
    });

    $('.wrap.wrap-project').fadeIn(400, function(){
      window.projectHidden = false;
      if(window.home && window.home.scene){
        window.home.scene.run = false;
      }
      $(mainWrap).addClass('end-sticky').css('opacity', 0); //.hide();
      $(mainWrap).scrollTop(window.prevScroll);
      setTimeout(function(){
        window.navigating = false;
      }, 100);
      checkFirstView();
    });

    // do large heading, this is the 4th argument for random cases
    if(dolarge) {
      console.log('doing large');
      $('.wrap--project .page--title, .wrap--project .page--title span').css({'opacity' : 1});
      var len = $('.page--title').children().length;
      if(len>0) {
        setTimeout(function(){
          $('.wrap--project .page--title').children().each(function(idx){
            var t = $(this);
            setTimeout(function(){
              $(t).css('opacity', 0);
            }, 150 * (len-idx));
          });
        }, 2000);
      } else {
        setTimeout(function(){
          $('.wrap--project .page--title').animate({'opacity' : 0}, 300);
        }, 1500);
      }
    }

    window.projectlinkclick = false;
    clearTimeout(window.cloneTimeout);
    window.cloneTimeout = setTimeout(function(){
      $(window.linkClone).each(function(){
        var len = $(this).children().length;
        $(this).children().each(function(idx){
          var t = $(this);
          setTimeout(function(){
            // console.log(idx, len);
            $(t).css('opacity', 0);
            if(idx==0){
              $('.clonetitle').remove();
              window.linkClone = null;
            }
          }, 150 * (len-idx));
        });
      });
    }, 2000);

    setTimeout(function(){
      initPage(); // has .wrap fadein
    }, 500);

    var title = $(projectWrap).attr('data-pagetitle');
    $('title').text(title);

    if(pushstate) {
      window.history.pushState({}, title, url);
    }
  });
}


function binds(){

  // $(window).unbind('scroll');
  console.log('binds');
  // ajax site

  window.onbeforeunload = function(){
    console.log('unload');
    localStorage.setItem('note-indexView', 'list');

    if(!window.internalNav) {
      console.log('no internalnav');
      localStorage.setItem('note-notis-folded','');
    }

    if(!window.preventUnload){
      $('.wrap, .end-sticky, .colophon, .menu').fadeOut(200);
      $('body').removeClass('in');
    }
  }

  $('.credits').unbind('click').click(function(e){
    $(this).toggleClass('hov');
  });

  var host = window.location.host;
  $('a[href*="'+host+'"]:not(.projectlink)').unbind('click').click(function(e) {
    e.preventDefault();
    if(!window.preventTitleHovers && !window.navigating) {
      window.internalNav = true;
      var href = $(this).attr('href');
      $('html').removeClass('ready');
      $('.header').removeClass('huge');
      // $('.wrap, .end-sticky, .menu').fadeOut(200);
      $('body').removeClass('in');
      $('.colophon').fadeOut(200, function(){
        window.location.href = href;
      });
    }
  });

  $('a.projectlink:not(.home--col--block--link)').unbind('click').click(function(e) {
    e.preventDefault();
    if(!window.preventTitleHovers && !window.navigating) {
      if($(this).hasClass('orange') || md.mobile()){
        var href = $(this).attr('href');
        // console.log('click');
        e.stopPropagation();
        window.previousNavFrom = $('html').attr('class');
        window.ajaxload(href, this);
      }
    }
  });

  // other project links
  if(siteurl.indexOf('localhost')>-1){
    $('a[href*="https://notedesignstudio.se"]').each(function(){
      var href = $(this).attr('href');
      var nuHref = href.replace('https://notedesignstudio.se', siteurl);
      $(this).attr('href',nuHref);
    });
  }

  let indexurl = siteurl+'/index';
  $('.studio--wrap a[href*="'+indexurl+'"]').unbind('click').click(function(e){
    e.preventDefault();
    if(!window.preventTitleHovers && !window.navigating && !window.preventUnload) {
      window.internalNav = true;
      var href = $(this).attr('href');
      $('html').removeClass('ready');
      $('.header').removeClass('huge');
      // $('.wrap, .end-sticky, .menu').fadeOut(200);
      $('body').removeClass('in');
      $('.colophon').fadeOut(200, function(){
        window.ajaxload(href);
        // window.location.href = href;
      });
      // window.previousNavFrom = $('html').attr('class');
      // var text = $('.image-index--title:not(.clonetitle)').first().get(0);
    }
  });

  $('a[href*="'+siteurl+'/index/"]:not(.projectlink):not(.projectlink--image)').unbind('click').click(function(e){
    // e.preventDefault();
    // console.log('now u clicked a tricky one');
    // if(!window.preventTitleHovers && !window.navigating) {
    //   $('.header.huge').removeClass('huge');
    //   window.internalNav = true;
    //   var href = $(this).attr('href');
    //   $('.notis .noti:not(.keksi)').removeClass('in');

    //   window.ajaxload(href, null, true, true);
    // }
  });

  $('a[href*="mailto"], a[href*="tel"], a[href*="Tel"]').unbind('click').click(function(){
    window.preventUnload = true;

    setTimeout(function(){
      window.preventUnload = false;
    }, 500);
  });

  if(!window.menuinited) {
    window.menuinited = true;
    $('.menu-button').unbind('click').click(function(e){
      e.preventDefault();
      if(!window.preventTitleHovers && !window.navigating) {
        $('html').toggleClass('nav-open');

        $(this).css('transform','scale(0)');

        setTimeout(function(){
          $('.menu-button').css('transform','').toggleClass('alt');
        }, 200);

        if(window.innerWidth<787) {
          if($('html').hasClass('nav-open')){
            clearInterval(window.scrollColophon);
            $('.colophon:not(.mobonly').removeClass('out');
            window.scrollColophon = setInterval(function(){
              let cur = $('.colophon:not(.mobonly').scrollLeft();
              $('.colophon:not(.mobonly').scrollLeft(cur+1);
            }, 30); // 30fps
          } else {
            setTimeout(function(){
              clearInterval(window.scrollColophon);
              $('.colophon:not(.mobonly').scrollLeft(2).addClass('out');
            }, 300);
          }
        }

        if(window.newsletterTypeTimeouts){
          for(let i=0; i<window.newsletterTypeTimeouts.length; i++){
            clearTimeout(window.newsletterTypeTimeouts[i]);
          }
        }

        window.newsletterTypeTimeouts = [];

        if($('html').hasClass('nav-open')){
          $('.newsletter-sub').attr('placeholder','');
          var newsletterPlaceholder = 'email address';
          var newsletterPlaceholderSplit = newsletterPlaceholder.split('');
          for(let i=0;i<newsletterPlaceholderSplit.length;i++){
            // clearTimeout(window.newsletterTypeTimeouts[i]);
            window.newsletterTypeTimeouts.push(setTimeout(function(){
              let ltr = newsletterPlaceholderSplit[i];
              let cur = $('.newsletter-sub').attr('placeholder');
              $('.newsletter-sub').attr('placeholder',cur+ltr);
            }, i*80));
          }
          $('#mce-error-response').empty();
        } else {
          // $('div.mce_inline_error, #mce-responses').hide();
        }
      }
    });
  }

  // lazy load

  /*
  $('.content-block [src]:not([data-src]):not(.no-lazy)').each(function(){
    var src = $(this).attr('src');
    var srcset = $(this).attr('srcset');
    if(WEBP){
      $(this).attr({
        'src' : '',
        'data-src' : src,
      });
      if(srcset) {
        $(this).attr({
          'srcset' : '',
          'data-srcset' : srcset,
        });
      }
    }
  });
  */

  // if(!WEBP) {
  //   $('[srcset]:not([data-srcset])').each(function(){
  //     $(this).attr('srcset', $(this).attr('data-srcset-jpeg'));
  //   });
  // }

  $(window).scroll(function(){
    $('[data-src]:not(.ok):not(.loading):visible, .image--project img:not(.ok):not(.loading)').each(function(){
      if(this.getBoundingClientRect().top < window.innerHeight * (MOBILE ? 1.5 : 3.0)){
        var src = $(this).attr('data-src');

        var srcset = $(this).attr('data-srcset');
        // if(!WEBP) {
        //   srcset = $(this).attr('data-srcset-jpeg');
        // }

        $(this).addClass('loading');

        var t = $(this).get(0);

        if($(this).is('video')) {
          // t = this;
          t.onload = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }
          t.onloadeddata = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }
          setTimeout(function(){
            t.src = src;
          }, 1);
        } else {
          var img = new Image();

          if(img.complete) {
            // console.log('img was complete');
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }
          img.onload = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }
          img.onloadeddata = function(){
            // console.log('img load');
            $(t).addClass('ok').removeClass('loading');
            $(t).parents('ul[style]').first().css('opacity',1);
          }

          img.src = src;
          t.src = src;

          if(srcset) img.srcset = srcset;
          if(srcset) t.srcset = srcset;
          //
          // $(img).attr({
          //   'src' : src,
          //   'srcset' : srcset,
          // });
          // $(this).attr({
          //   'src' : src,
          //   'srcset' : srcset,
          // });
        }
      }
    });
  });

  $('.text-cols--col > ul > li > *').click(function(e){
    if($(this).siblings().length>0) {
      if(!$(e.target).is('a')){
        $(this).parent().toggleClass('act');
        $(this).parent().children('ul').slideToggle(200);
        if($(this).parent().hasClass('act')){
          $(this).parent().siblings('.act').children('ul').slideUp(200);
          $(this).parent().siblings('.act').removeClass('act');
        }
      }
    }
  }).each(function(){
    if($(this).siblings().length==0) {
      $(this).parent().addClass('no-open');
    }
  });

  $('a.textindex').unbind('click').click(function(e){
    e.preventDefault();
    console.log('should set note-indexView');
    localStorage.setItem('note-indexView', 'list');
    console.log(localStorage.getItem('note-indexView'));
    var href = $(this).attr('href');
    setTimeout(function(){
      window.location.href = href;
    }, 20);
  });

  $('.newsletter-sub').on('blur', function(){
    $('.mce_inline_error').text('');
    setTimeout(function(){
      $('.mce_inline_error').text('');
    }, 10);
  });

  $('.projectlink--image').unbind('click').click(function(e){
    e.preventDefault();
    if(!window.preventTitleHovers && !window.navigating) {
      var url = $(this).attr('href');
      window.previousNavFrom = $('html').attr('class');
      var text = $('.image-index--title:not(.clonetitle)').first().get(0);
      window.ajaxload(url, text);
    }
  });
} // end binds

function initOnce(){
  if(window.innerWidth < 787) {
    $('.colophon:not(.mobonly)').each(function(){
      $(this).addClass('out');
      $(this).children().clone().appendTo(this);
    });

    $('.colophon:not(.mobonly').unbind('scroll').on('scroll', function(){
      var lastElement = $(this).children().last();
      var lastRight = $(this.children).last().get(0).getBoundingClientRect().right;

      var left = $(this).scrollLeft();
      // console.log(left);
      if(left < 10) {
        $(lastElement).prependTo(this);
        $(this).scrollLeft($(lastElement).outerWidth()+10);
      }
      else if(lastRight < window.innerWidth+10) { $(this).scrollLeft($(lastElement).outerWidth()-11 - window.innerWidth); }
    });
  }
}

function vh(){
  window.vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${window.vh}px`);

  window.maxvh = window.innerHeight*0.01;
  document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
}

function resize(){
  let newMainWidth = $('main').outerWidth();
  if(newMainWidth!==mainWidth || !md.mobile()){
    vh();
  }
  mainWidth = newMainWidth;

  if((window.innerHeight*0.01) > window.maxvh){
    window.maxvh = window.innerHeight*0.01;
    document.documentElement.style.setProperty('--maxvh', `${window.maxvh}px`);
  }
}

$(window).resize(function(){
  resize();
});
